import React from 'react';
import { Typography } from '@material-ui/core';
import styles from '../InstructionsStyles';

const Instr18 = () => {
  return (
    <div style={styles.container}>
      <Typography variant="subtitle1" style={styles.madeBy}>
        Утвърдил: Габриела Илиева
      </Typography>
      <Typography variant="subtitle1" style={styles.madeBy}>
        Старши експерт &quot;Здравословна работна среда&quot;
      </Typography>
      <Typography variant="subtitle1" style={styles.title}>
        <b>ЗА ОКАЗВАНЕ НА ПЪРВА ДОЛЕКАРСКА ПОМОЩ НА ПОСТРАДАЛИ ПРИ ЗЛОПОЛУКИ</b>
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>I.Оказване на първа помощ при поражение от електрически ток.</b>
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1. Спасяването на пострадалия</b> в повечето случаи зависи от това, колко бързо е бил
        освободен от електрически ток и дали бързо и правилно е оказана първа помощ. Забавянето е
        гибелно за пострадалия.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>2. Никога не трябва</b> да се отказва да се дава първа помощ на пострадалия или да се
        счита за мъртъв на основание само на това, че у него няма признаци на живот - дишане, пулс.
        При удари от електрически ток често пъти смъртта бива привидна / мнима / и само лекарят може
        да реши въпроса за безполезността от по-нататъшни усилия за съживяването на пострадалия и да
        даде заключение, че пострадалият е умрял.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>3. Първото нещо, което трябва да се направи</b> при освобождаване от електрически ток, е
        изключване на тази част от уредбата, към която е допрян пострадалият. При това трябва да се
        спазва следното:
      </Typography>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          • В случая, че пострадалият се намира нависоко, изключването на тока може да предизвика
          падането му, следователно трябва да се вземат мерки за безопасното му сваляне. В противен
          случай необмисленото изключване на тока може да причини повече злини от самия ток;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          • При изключване на уредбата може да угасне и осветлението, затова трябва да се набави
          друг източник за осветление, не задържайки при това изключването на уредбата и даване
          помощ на пострадалия. Ако напрежението не може да се изключи бързо, налага се да се вземат
          мерки за отстраняване на пострадалия от тоководещата част, към която той е прикрепен.
        </Typography>
      </div>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>4. За отстраняване </b>на пострадалия от тоководещи части , трябва да се използват сухи
        дрехи, сухо въже, суха дъска или прът или какъвто и да е сух изолиран предмет.За да се
        откъсне пострадалият от тоководещите части, той може да бъде хванат за дрехите, ако те са
        сухи и не прилепват до тялото. Пострадалият не трябва да се дърпа за краката без
        предварителното добро изолиране на ръцете на спасяващия, тъй като обувките могат да бъдат
        влажни, а и намиращите се в тях пирони са проводници на тока. Предварително спасяващият
        трябва да вземе мерки за изолация, като стъпи на изолирана повърхност / суха дъска и др. /.
      </Typography>
      <Typography>
        Мерките за първа помощ зависят от състоянието в което се намира пострадалият след
        освобождаването му от електрически ток, а именно:
      </Typography>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          • Ако пострадалият е дошъл в съзнание, но дотогава е бил в безсъзнание, или дълго време е
          бил под електрически ток, то предвид възможността от влошаване на положението му е
          необходимо да се отправи при лекар. При тежки случаи трябва да се извика лекар на мястото
          на злополуката;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          • При състояние на безсъзнание пострадалият трябва да се положи удобно, на равно, да се
          отпуснат и разхлабят дрехите му, да се създаде приток на свеж въздух, да се отстраният
          излишните хора, разтрива се тялото и се вика лекарят незабавно.Ако пострадалият диша лошо,
          много рядко и конвулсивно като умиращ - да му се направи изкуствено дишане. В никакъв
          случай пострадалият не трябва да се заравя в земята., тъй като това не е полезно.
        </Typography>
      </div>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          5. При спиране на дишането се провежда
          <span style={styles.warning}>изкуствено дишане</span>
        </b>
        на мястото на произшествието. Необходимост от изкуствено дишане възниква след запушване на
        дихателните пътища, при мозъчни кръвоизливи, травматичен шок, поражения от електрически ток
        и други остри заболявания и травми.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>6. Най- простият ефективен метод</b> е изкустеното дишане уста в уста и уста в нос.
        Ефективността на този метод е несъмнена, тъй като въздухът, вдухван от оказващия помощ,
        съдържа 16-18% кислород, което е достатъчно за обогатяване на кръвта на пострадалия.
        Изкуственото дишане се изпълнява по следния начин: пострадалият се поставя по гръб, като
        главата му се отмята назад; дрехите му се розхлабват, при необходимост устната кухина и
        глътката се почистват от чужди тела /пясък, земя, повърната материя и други /. Желателно е
        да се отстранят налични протези. След почистането на устната кухина оказващият помощ застава
        отстрани на пострадалия и покрива устата и носа му с чиста кърпа или бинт; след като поема
        дълбоко въздух той енергично го издишва в устата на пострадалия, като същовременно запушва
        носа му. При изпълнение на изкуствено дишане уста в нос по време на вдухването в носа се
        затваря устата на пострадалия. Ако след вдухването на въздух /15-20 пъти в минута / гръдният
        кош на пострадалия се разширява, това означава, че в неговите бели дробове постъпва въздух.
        Издъшването става пасивно за сметка на еластичността на гръдния му кош. По движението на
        гръдния кош може да се съди за ефективността на искуственото дишане. То продължава до
        въстановяване на собственото дишане.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>7. Техника на външния сърдечен масаж.</b> Външният масаж на сърцето се изпълнява по
        следния начин: пострадалия се поставя по гръб върху плътна основа /под, земя /; оказващия
        помощ застава встрани от нето и с дланни повърхности, наложени една върху друга, ритмично
        силно натиска /50-60 пъти в минута / в облостта на долната кост по посока към гръбначния
        стълб. Гръдната кост трябва да хлътва с 4-5 см. Външният сърдечен масаж при деца на възраст
        до една година трябва да се провежда с краищата на пръстите с честота 100-120 в минута, а
        при от 1 до 12 години - както при възрастни, но само с една ръка. Ако реанимацията се
        изпълнява само от един човек, се препоръчва след 10-12 притискания на гърдите да се правят 2
        вдухвания в белите дробове на пострадалия. Ако тя се изпълнява от двама души, то едно
        вдухване следва след 5-6 притискания на гръдния кош. Необходимо е да се знае, че грубото
        изпълнение може да доведе до счупване на ребра, с повреждане на белите дробове, сърцето и
        други органи. Препоръчва се сърдечния масаж да се предхожда от удар с юмрук в гърдите, при
        което е възможно да се въстанови сърдечната дейност.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>II.Първа помощ при травматични увреждания</b>
      </Typography>
      <Typography>
        Травматичните увреждания /травми/ се причиняват от действие на външни агенти върху организма
        /механични, химични и биологични/. Травматичните увреди на тялото биват затворени и
        отворени. При първите целостта на покривните тъкани - кожа и лигавици - е запазена, а при
        вторите - нарушена. Всяка травма се придружава от следните признаци: болка, кръвотечение,
        разрушаване на тъкани, инфекция и нарушение на функцията на увредените тъкани и органи.
        Контузиите и нараняванията могат да бъдат различно тежки според вида и силата на действащия
        външен агент и засягането на различните телесни части в дълбочина и по площ. Изходът от тях
        зависи до голяма степен от функционалната годност и съпротивителните сили на организма.
      </Typography>
      <Typography>
        Първа помощ при открити наранявания. Раната представлява травматично увреждане, при което е
        нарушена целостта на покривните тъканите / кожа, лигавици / и на подлежащите тъкани. Раните
        биват:
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1. Контузии. </b>Те се получават при удар с тъп твърд предмет. Краищата на такава рана са
        неравни, но не кървят. Мястото около раната има синкав цвят;
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>2. Разкъсано-контузни.</b> При тях има голямо разкъсване на тъканите. Такива са раните
        при ухапване от куче, раздиране от остър предмет, убождане от пирон;
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>3. Порезни.</b> Те се получават при порязване с нож, коса, стъкло. В зависимост от
        дълбочината на порязването кървенето е различно;
      </Typography>
      <b>4. Огнестрелни.</b> Те се предизвикват от действие на огнестрелно оръжие;
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>5. Прободни.</b> Те се причиняват от остри тесни предмети /игла, кол, шило/;
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>6. Рани от ухапване.</b> Те се предизвикват от ухапване на животни и насекоми. По раната
        се забелязват следи от ухапването. По правило те са предимно разкъсано- контузни или
        прободни и много често се инфектират. При оказване на първа помощ при различните видове
        наранявания трябва да се спазват следните общи правила:
      </Typography>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          • Да не се бърка с пръсти в раната при вадене на чужди тела;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          • Преди налагане на превръзката ръцете да се измиват с вода и сапун;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          • Да се използуват чисти /стерилни/ превързочни материали;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          • Ако след превръзката раната се напои с кръв, превръзката не трябва да се сменя, а върху
          нея се поставя памук и се прави стегната надвръзка. Първата помощ при нараниявания
          включва: Обработване на раната; Превързване на раната. Обработката на раната се състои от:
          промиване с кислородна вода; почистване на кожата около раната с памук, напоен със спирт,
          йод-бензин или йодна тинктура; върху раната се поставят сулфатиацил и стерилна
          марля;превръзката се извършва с левкопласт и бинт; при повърхностни или слабо кървящи рани
          може да се постави анкерпласт, без да се налага поставяне на сулфатиацил или марля, като
          почистването на полето около раната е задължително; пострадалият веднага се насочва към
          медицинското заведение.
        </Typography>
      </div>
      <Typography>
        Превръзката трябва да е плътна, но да не притиска силно превързаната част. За тази цел с
        лявата ръка се държи краят на бинта, а с дясната - самия бинт. Навиването на бинта се
        извършва от ляво на дясно, като се започва от по- тънката част на тялото или крайника и се
        отива към по- дебелата. Ходовете на бинта могат да бъдат кръгови, спирални или кръстосани.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>III. Кръвотечение и кръвоспиране</b>
      </Typography>
      <Typography>
        Кръвотечението е почти неизбежен спътник на наравяването. Различават се следните видове
        кръвотечения:
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1. Артериално </b>- при него кръвта е ярко-червена и изтича на тласъци;
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>2. Венозно </b>- кръвта има по-тъмен цвят и изтича на струя;
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>3. Капилярно </b>- кръвта изтича на капки и се стича по повърхността на нараненото място.
        В зависимост от това дали кръвта изтича навън от тялото или във вътрешните телесни кухини
        кръвотеченията биват външни и вътрешни. Освен при наранявания кръвотечения могат да
        възникнат и при някои вътрешни заболявания: туберкулоза, язвена болест, варикоза,
        сърдечно-съдови заболявания, различни видове на раковата болест.
      </Typography>
      <Typography>
        Оказването на първа помощ при кръвотечения, предизвикани отнараниявания, трябва да включва
        комплекс от манипулации за спиране на кръвотечението и своевременно придвижване на
        пострадалия до медицинско заведение:
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1. Да се действа бързо и уверено;</b>
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          2. Крайникът или наранената част да се постави на високо и тогава да се пристъпи към
          кръвоспиране;
        </b>
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          3. Да се познават елементарните способи за спиране на кръвотечение с подръчни и
          универсални средства
        </b>
      </Typography>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          а/при силен кръвоизлив /артериален / да се извърши притискане на кръвоносния съд. За тази
          цел може да се използва притискане с пръст в самата рана;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          б/ притискане на главната артерия, кръвоснабдяваща крайника.Това най-често става на място,
          където тази артерия се намира. Притискането се извършва с пръсти. За горния крайник това
          място е от вътрешната страна на мишницата, а за долния - в слабинната гънка;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          в/ пристягане на крайника на 2-3 см над мястото на кръвотечението. Извършва се с гумен
          маркуч, колан, кърпа, турникет, бинт или други подръчни средства. При този начин на
          кръвоспиране се притискат всички кръвоносни съдове. Правилно е да се пристяга, докато
          изчезне пулсът под мястото на притискането. Тъй като при пристягането кръвообращението се
          прекъсва, то пострадалият трябва най-късно за един час да бъде транспортиран до лечебно
          заведение. Необходимо е да се отбележи точно часът и минутата на поставянето на
          пристягащото средство. При всички случаи на кръвоспиране с пристягане трябва да се направи
          превръзка на раната;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          г/при слабо артериално, венозно или капилярно кръвотечение кръвоспирането се извършва с
          плътно пристегната компресивна превръзка. Ако превръзката се пропие с кръв, то тя не се
          сваля, а се прави надвръзка;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          д/кръвотечение в тъканите /кръвонасядане/ се спира с притискаща превръзка;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          е/кръвотечение от носа се спира, като се постави пострадалия седнал или легнал по гръб със
          силно извита глава В носа се поставя памук или марля, напоени с кислородна вода;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          ж/Нараниявания на главата се получават най-често при удар с тъп твърд предмет или при
          падане. Най-сериозни увреди при нараняване на главата на мозъчно сътресение и счупване на
          черепа, което се придружава от кръвотечение от носа, ушите или устата. Появяват се
          подкожни кръвоизливи около очите под формата на очила. При този вид кръвотечение
          пострадалият задължително се поставя в легнало положение по гръб, а на главата се поставя
          лед или бутилка със студена вода и студени кърпи. Главата трябва да бъде добре фиксирана
          към носилката. На краката се поставят бутилки с топла вода. Пострадалиятсе транспортира до
          най-близката болница;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          з/Кръвотечения в телесните кухини могат да се предизвикат от отсрити и закрити
          нараниявания или от вътрешни заболявания. Пострадалият е унесен, оплаква се от жажда,
          кожата и лигавиците са бледи, пулсът едва се напипва. Той може да бъде и в безсъзнание.
          Такива пострадали се транспортират веднага в болница. Върху корема или гръдния кош се
          поставя лед или бутилки със студена вода. Главата трябва да е повдигната, а краката -
          свити в колене. При кръвохрачение на пострадалия се дава да пие солена вода или да глъта
          парченца лед.
        </Typography>
      </div>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>IV. Оказване на първа помощ при изгаряне</b>
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1. Изгаряния биват три степени </b>- от леко зачервяване до тежко умъртвяване на части от
        кожата, понякога и на по дълбоко намиращите се тъкани. При тежки изгаряния трябва много
        внимателно да се снемат дрехите и обувките, като е по - добре да се разрежат. Изгорената
        част от кожата не трябва да се докосва с ръце или да се маже с някакви масла, мехлеми,
        вазелин или разтвори. Изгорената повърхност трябва да се превърже като прясна рана; да се
        покрие със стерилен материал или чисто изгладено парче плат; отгоре да се постави памук и
        всичко това да се превърже с бинт, след което пострадалият се отправя в лечебно заведение.
        Също така не трябва да се пукат мехурите, да се отстраняват полепнали смоли, прилепналите
        изгорели части от дрехите.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>2. При обгаряне на очите</b> с волтова дъга се прави студени компреси от борова вода
        върху очите, а пострадалият незабавно се отправя на лекар.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>3. Обгарянията с химични вещества </b>- най-вече от силни киселини и разяждащи основи,
        изискват незабавно обилно промиване на пострадалата кажа с бързотечаща водна струя в
        продължение на 10-15 минути. След внимателно измиване на изгорялата кожа с вода, върху нея
        трябва да се наложи компрес, при изгаряне с киселина - от разтвор на сода бикарбонат /една
        чаена лъжичка в една чаша вода / , а при изгаряне с основи - слаб оцетен разтвор или от
        разтвор на борова киселина /една чаена лъжичка на чаша вода /.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>V. Оказване на първа помощ при измързване</b>
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1. Съгласно медицинските предписания </b>не се препоръчват разтриването на замръзналите
        части на тялото със сняг. Най -добре е за разтриване на замръзналите части на тялото да се
        употребяват сухи топли ръкавици или вълнени ръкавици. Когато пострадалият е в помещение,
        замръзналият крайник може да се потопи в съд с вода с обикновена стайна температура. Водата
        трябва постепенно да се сменя с по-топла, докато се постигне изравняване на нейната
        температура с тази на тялото 1У7С.1. Когато се зачерви, измръзналото място се намазва с
        мазнина /масло, сукнена и др./. След като се превърже, измръзналият крайник трябва да се
        държи малко повдигнат. Това намалява болките и предпазва от усложнения.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          VI. Оказване на първа помощ при счупвания, изкълчвания, натъртвания и разтягане на
          сухожилия
        </b>
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1. При счупвания и изкълчвания </b>първата задача е да се обездвижи счупеният крайник.
        При увреждане на главата , което предизвиква изпадане в безсъзнание, кръвотечение, първата
        помощ се състои в поставяне на студено на главата /бутилка със сняг или студена вода, студен
        компрес/.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>2. При счупване на гръбнака</b>, първата помощ се състои в следното:
      </Typography>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - Внимателно, без да се повдига пострадалият от земята, под него се поставя дъска и строго
          се следи тялото да не се прегъва при повдигането му /за избягване на повреда на гръбначния
          мозък/.
        </Typography>
      </div>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>3. При натъртвания на мястото </b>се поставя студено и се забинтова плътно с бинт. Ако
        кожата не е наранена , не трябва да се намазва с йод, да се разтрива , да се прави горещ
        компрес , защото това води до усилване на болките. При натъртвания на корема и при наличие
        на припадъчно състояние, силно изразена бледност на лицето и силни болки, трябва незабавно
        пострадалият да се отправи в болница. По този начин трябва да се постъпва и при тежки
        натъртвания на цялото тяло при падане.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>4. При разтягане на сухожилията </b>се прилага изстудяване , стегнато бинтоване и покой.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>VII. Пренасяне на пострадалия</b>
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1. При повдигане, пренасяне и превозване на пострадалия </b>е необходимо да не му се
        причиняват безпокойства и болки, да не се допускат сътресения и да не се поставя в опасно
        положение. При най-малката възможност пострадалият да се пренесе на носилка, направена от
        подръчни материали. Повдигането на пострадалия и слагането му на носилка трябва да става
        съгласувано. Пострадалият се хваща от едната страна /здравата/, като се стои на едно коляно
        без то да се сменя. Ръката трябва да се пъхне под гърба така, че пръстите да се покажат от
        другата страна на пострадалия. При счупване на гръбнака, ако носилката е мека, а също при
        счупване на долната челюст, ако пострадалият се задушава, трябва да се постави по лицето
        надолу. При равно място пострадалият се носи с краката напред, а при изкачване с главата
        напред. Носилката трябва да се поддържа в хоризонтално положение. При снемане на пострадалия
        от носилката се постъпва по същия начин, както при слагането му върху нея.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>2. При превозване на пострадалия </b>е по-добре , ако е възможно , да го поставят /без да
        го преместват/ на колата със същата носилка. Колата трябва да се кара внимателно, за да се
        избягнат сътресенията. Мерките при първа помощ не трябва да се прекратяват по време на
        транспортирането.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>VIII. Оказване първа помощ при нараняване на очите</b>
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1. При попадане на чуждо тяло в окото </b>се прави опит да се извади по следния начин:
        обръща се с чисти ръце клепачът, под който е заседнало тялото и се отстранява с върха на
        чиста кърпа или с върха на чист памучен фитил. Ако обаче, чуждото тяло е заседнало и се
        набило в роговицата или в клепача, окото не се пипа, а се търси лекарска помощ.
      </Typography>
      <Typography style={styles.date}>
        <b>7.10.2024г.</b>
      </Typography>
    </div>
  );
};
export default Instr18;
